var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTariaSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsv: "https://svgstorm.com",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#000000",
    strokeOpacity: 0,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 160.00  L 160.00 160.00 L 160.00 0.00 L 0.00 0.00 L 0.00 160.00 M 90.00 8.00  C 142.17 14.31 168.47 81.77 136.25 122.25 C 104.02 162.73 38.04 160.51 14.70 110.30 C -8.65 60.10 32.39 1.04 90.00 8.00 Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#282727",
    strokeOpacity: 0.98,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 8.00  C 32.39 1.04 -8.65 60.10 14.70 110.30 C 38.04 160.51 104.02 162.73 136.25 122.25 C 168.47 81.77 142.17 14.31 90.00 8.00 M 118.00 30.00  C 121.32 32.62 124.42 35.73 127.00 39.00 C 133.17 46.81 137.48 55.56 140.00 65.00 C 147.05 91.39 133.24 117.62 110.77 131.77 C 88.31 145.92 57.82 141.62 38.00 124.00 C 13.55 102.26 10.38 64.22 31.75 38.75 C 53.12 13.28 92.08 9.54 118.00 30.00 Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#D0D0D0",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 38.00 124.00  C 42.63 125.65 45.46 122.01 50.00 121.00 C 49.19 118.96 46.73 118.03 46.00 116.00 C 31.76 99.34 25.10 78.03 34.92 57.92 C 44.75 37.82 65.03 28.68 85.22 30.78 C 105.41 32.88 123.84 49.16 127.00 69.00 C 130.44 72.92 135.99 66.79 140.00 65.00 C 137.48 55.56 133.17 46.81 127.00 39.00 C 124.33 36.11 120.84 32.62 118.00 30.00 C 92.08 9.54 53.12 13.28 31.75 38.75 C 10.38 64.22 13.55 102.26 38.00 124.00 Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#575757",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 46.00 116.00  C 80.36 147.77 134.03 113.19 127.00 69.00 C 123.84 49.16 105.41 32.88 85.22 30.78 C 65.03 28.68 44.75 37.82 34.92 57.92 C 25.10 78.03 31.76 99.34 46.00 116.00 M 82.00 79.00  C 80.27 81.64 74.18 79.57 74.00 79.00 C 71.99 72.55 78.35 58.45 66.00 57.00 C 69.40 49.94 60.89 44.13 57.00 41.00 C 69.73 34.45 86.40 34.07 99.00 41.00 C 95.11 44.10 86.60 49.95 90.00 57.00 C 80.59 59.47 79.86 71.10 82.00 79.00 M 59.00 61.00  C 70.00 60.62 72.68 77.22 63.00 81.00 C 72.86 94.78 56.46 103.73 57.00 117.00 C 46.37 110.45 37.89 97.80 36.02 85.98 C 34.16 74.16 35.52 71.88 38.33 62.33 C 41.14 52.77 50.36 69.36 46.00 74.00 C 52.14 73.11 52.35 80.51 54.00 84.00 C 60.77 79.01 55.13 72.81 52.30 68.70 C 49.48 64.59 52.07 54.52 44.00 54.00 C 46.94 40.87 66.51 49.49 59.00 61.00 M 112.00 54.00  C 103.91 54.58 106.55 64.54 103.67 68.67 C 100.79 72.80 95.34 79.06 102.00 84.00 C 103.60 80.43 103.87 73.17 110.00 74.00 C 109.73 68.02 108.76 58.89 117.00 59.00 C 126.79 77.88 121.03 106.56 100.00 115.00 C 94.16 106.31 101.81 91.99 93.25 84.75 C 84.68 77.51 84.26 62.21 97.00 61.00 C 89.07 49.55 110.05 40.49 112.00 54.00 M 94.00 119.00  C 88.28 124.18 77.89 118.31 80.78 111.78 C 83.68 105.24 88.70 97.45 80.00 94.00 C 84.15 104.27 68.40 110.89 75.00 122.00 C 50.00 120.26 79.86 98.51 71.00 86.00 C 78.44 84.62 90.58 85.63 91.32 94.68 C 92.06 103.73 89.29 110.74 94.00 119.00 Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#878488",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 39.00  C 124.42 35.73 121.32 32.62 118.00 30.00 C 120.84 32.62 124.33 36.11 127.00 39.00 Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#D0CFCF",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 74.00 79.00  C 76.41 78.21 79.53 79.59 82.00 79.00 C 79.86 71.10 80.59 59.47 90.00 57.00 C 86.60 49.95 95.11 44.10 99.00 41.00 C 86.40 34.07 69.73 34.45 57.00 41.00 C 60.89 44.13 69.40 49.94 66.00 57.00 C 78.35 58.45 71.99 72.55 74.00 79.00 Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#CAC9C9",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 59.00 61.00  C 66.51 49.49 46.94 40.87 44.00 54.00 C 52.07 54.52 49.48 64.59 52.30 68.70 C 55.13 72.81 60.77 79.01 54.00 84.00 C 52.35 80.51 52.14 73.11 46.00 74.00 C 50.36 69.36 41.14 52.77 38.33 62.33 C 35.52 71.88 34.16 74.16 36.02 85.98 C 37.89 97.80 46.37 110.45 57.00 117.00 C 56.46 103.73 72.86 94.78 63.00 81.00 C 72.68 77.22 70.00 60.62 59.00 61.00 Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#C1C0C0",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 112.00 54.00  C 110.05 40.49 89.07 49.55 97.00 61.00 C 84.26 62.21 84.68 77.51 93.25 84.75 C 101.81 91.99 94.16 106.31 100.00 115.00 C 121.03 106.56 126.79 77.88 117.00 59.00 C 108.76 58.89 109.73 68.02 110.00 74.00 C 103.87 73.17 103.60 80.43 102.00 84.00 C 95.34 79.06 100.79 72.80 103.67 68.67 C 106.55 64.54 103.91 54.58 112.00 54.00 Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#B5B4B4",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 69.00  C 134.03 113.19 80.36 147.77 46.00 116.00 C 46.73 118.03 49.19 118.96 50.00 121.00 C 45.46 122.01 42.63 125.65 38.00 124.00 C 57.82 141.62 88.31 145.92 110.77 131.77 C 133.24 117.62 147.05 91.39 140.00 65.00 C 135.99 66.79 130.44 72.92 127.00 69.00 Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#8F8E8E",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 82.00 79.00  C 79.53 79.59 76.41 78.21 74.00 79.00 C 74.18 79.57 80.27 81.64 82.00 79.00 Z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#BBBABA",
    strokeOpacity: 1,
    strokeWidth: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 94.00 119.00  C 89.29 110.74 92.06 103.73 91.32 94.68 C 90.58 85.63 78.44 84.62 71.00 86.00 C 79.86 98.51 50.00 120.26 75.00 122.00 C 68.40 110.89 84.15 104.27 80.00 94.00 C 88.70 97.45 83.68 105.24 80.78 111.78 C 77.89 118.31 88.28 124.18 94.00 119.00 Z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillOpacity: 0,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 0.00 160.00  L 160.00 160.00 L 160.00 0.00 L 0.00 0.00 L 0.00 160.00 M 90.00 8.00  C 142.17 14.31 168.47 81.77 136.25 122.25 C 104.02 162.73 38.04 160.51 14.70 110.30 C -8.65 60.10 32.39 1.04 90.00 8.00 Z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    fill: "#282727",
    fillOpacity: 0.98,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 90.00 8.00  C 32.39 1.04 -8.65 60.10 14.70 110.30 C 38.04 160.51 104.02 162.73 136.25 122.25 C 168.47 81.77 142.17 14.31 90.00 8.00 M 118.00 30.00  C 121.32 32.62 124.42 35.73 127.00 39.00 C 133.17 46.81 137.48 55.56 140.00 65.00 C 147.05 91.39 133.24 117.62 110.77 131.77 C 88.31 145.92 57.82 141.62 38.00 124.00 C 13.55 102.26 10.38 64.22 31.75 38.75 C 53.12 13.28 92.08 9.54 118.00 30.00 Z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    fill: "#D0D0D0",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 38.00 124.00  C 42.63 125.65 45.46 122.01 50.00 121.00 C 49.19 118.96 46.73 118.03 46.00 116.00 C 31.76 99.34 25.10 78.03 34.92 57.92 C 44.75 37.82 65.03 28.68 85.22 30.78 C 105.41 32.88 123.84 49.16 127.00 69.00 C 130.44 72.92 135.99 66.79 140.00 65.00 C 137.48 55.56 133.17 46.81 127.00 39.00 C 124.33 36.11 120.84 32.62 118.00 30.00 C 92.08 9.54 53.12 13.28 31.75 38.75 C 10.38 64.22 13.55 102.26 38.00 124.00 Z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    fill: "#575757",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 46.00 116.00  C 80.36 147.77 134.03 113.19 127.00 69.00 C 123.84 49.16 105.41 32.88 85.22 30.78 C 65.03 28.68 44.75 37.82 34.92 57.92 C 25.10 78.03 31.76 99.34 46.00 116.00 M 82.00 79.00  C 80.27 81.64 74.18 79.57 74.00 79.00 C 71.99 72.55 78.35 58.45 66.00 57.00 C 69.40 49.94 60.89 44.13 57.00 41.00 C 69.73 34.45 86.40 34.07 99.00 41.00 C 95.11 44.10 86.60 49.95 90.00 57.00 C 80.59 59.47 79.86 71.10 82.00 79.00 M 59.00 61.00  C 70.00 60.62 72.68 77.22 63.00 81.00 C 72.86 94.78 56.46 103.73 57.00 117.00 C 46.37 110.45 37.89 97.80 36.02 85.98 C 34.16 74.16 35.52 71.88 38.33 62.33 C 41.14 52.77 50.36 69.36 46.00 74.00 C 52.14 73.11 52.35 80.51 54.00 84.00 C 60.77 79.01 55.13 72.81 52.30 68.70 C 49.48 64.59 52.07 54.52 44.00 54.00 C 46.94 40.87 66.51 49.49 59.00 61.00 M 112.00 54.00  C 103.91 54.58 106.55 64.54 103.67 68.67 C 100.79 72.80 95.34 79.06 102.00 84.00 C 103.60 80.43 103.87 73.17 110.00 74.00 C 109.73 68.02 108.76 58.89 117.00 59.00 C 126.79 77.88 121.03 106.56 100.00 115.00 C 94.16 106.31 101.81 91.99 93.25 84.75 C 84.68 77.51 84.26 62.21 97.00 61.00 C 89.07 49.55 110.05 40.49 112.00 54.00 M 94.00 119.00  C 88.28 124.18 77.89 118.31 80.78 111.78 C 83.68 105.24 88.70 97.45 80.00 94.00 C 84.15 104.27 68.40 110.89 75.00 122.00 C 50.00 120.26 79.86 98.51 71.00 86.00 C 78.44 84.62 90.58 85.63 91.32 94.68 C 92.06 103.73 89.29 110.74 94.00 119.00 Z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    fill: "#878488",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 39.00  C 124.42 35.73 121.32 32.62 118.00 30.00 C 120.84 32.62 124.33 36.11 127.00 39.00 Z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    fill: "#D0CFCF",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 74.00 79.00  C 76.41 78.21 79.53 79.59 82.00 79.00 C 79.86 71.10 80.59 59.47 90.00 57.00 C 86.60 49.95 95.11 44.10 99.00 41.00 C 86.40 34.07 69.73 34.45 57.00 41.00 C 60.89 44.13 69.40 49.94 66.00 57.00 C 78.35 58.45 71.99 72.55 74.00 79.00 Z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    fill: "#CAC9C9",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 59.00 61.00  C 66.51 49.49 46.94 40.87 44.00 54.00 C 52.07 54.52 49.48 64.59 52.30 68.70 C 55.13 72.81 60.77 79.01 54.00 84.00 C 52.35 80.51 52.14 73.11 46.00 74.00 C 50.36 69.36 41.14 52.77 38.33 62.33 C 35.52 71.88 34.16 74.16 36.02 85.98 C 37.89 97.80 46.37 110.45 57.00 117.00 C 56.46 103.73 72.86 94.78 63.00 81.00 C 72.68 77.22 70.00 60.62 59.00 61.00 Z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    fill: "#C1C0C0",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 112.00 54.00  C 110.05 40.49 89.07 49.55 97.00 61.00 C 84.26 62.21 84.68 77.51 93.25 84.75 C 101.81 91.99 94.16 106.31 100.00 115.00 C 121.03 106.56 126.79 77.88 117.00 59.00 C 108.76 58.89 109.73 68.02 110.00 74.00 C 103.87 73.17 103.60 80.43 102.00 84.00 C 95.34 79.06 100.79 72.80 103.67 68.67 C 106.55 64.54 103.91 54.58 112.00 54.00 Z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    fill: "#B5B4B4",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 127.00 69.00  C 134.03 113.19 80.36 147.77 46.00 116.00 C 46.73 118.03 49.19 118.96 50.00 121.00 C 45.46 122.01 42.63 125.65 38.00 124.00 C 57.82 141.62 88.31 145.92 110.77 131.77 C 133.24 117.62 147.05 91.39 140.00 65.00 C 135.99 66.79 130.44 72.92 127.00 69.00 Z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    fill: "#8F8E8E",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 82.00 79.00  C 79.53 79.59 76.41 78.21 74.00 79.00 C 74.18 79.57 80.27 81.64 82.00 79.00 Z"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    fill: "#BBBABA",
    fillOpacity: 1,
    stroke: "None"
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 94.00 119.00  C 89.29 110.74 92.06 103.73 91.32 94.68 C 90.58 85.63 78.44 84.62 71.00 86.00 C 79.86 98.51 50.00 120.26 75.00 122.00 C 68.40 110.89 84.15 104.27 80.00 94.00 C 88.70 97.45 83.68 105.24 80.78 111.78 C 77.89 118.31 88.28 124.18 94.00 119.00 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTariaSilver);
export default __webpack_public_path__ + "static/media/Taria_Silver.b88864d3026ef42e38a27d8ef4bf63e8.svg";
export { ForwardRef as ReactComponent };